'use strict'

const stringify = require('json-stable-stringify')

const getKey = (method, params = []) => `${method}${stringify(params)}`

module.exports = getKey
